export const LooseLanguageSwitchLanguageOptions = {
  'nl-NL': 'NL',
  en: 'EN'
}
